import React from "react";
import { Box, Typography } from "@mui/material";
import ReactMarkdown from "react-markdown";

const components = {
  p: ({ children }) => (
    <Typography sx={{ whiteSpace: "pre-wrap", m: 0, "&:not(:last-child)": { mb: 1 } }}>
      {children}
    </Typography>
  ),
  strong: ({ children }) => <Box component="strong" sx={{ fontWeight: 700 }}>{children}</Box>,
  em: ({ children }) => <Box component="em" sx={{ fontStyle: "italic" }}>{children}</Box>,
  ul: ({ children }) => (
    <Box component="ul" sx={{ m: 0, mb: 1, pInlineStart: 3 }}>
      {children}
    </Box>
  ),
  ol: ({ children }) => (
    <Box component="ol" sx={{ m: 0, mb: 1, pInlineStart: 3 }}>
      {children}
    </Box>
  ),
  li: ({ children }) => (
    <Typography component="li" sx={{ mb: 0.25 }}>
      {children}
    </Typography>
  ),
  h1: ({ children }) => <Typography sx={{ fontWeight: 700, fontSize: "1.15em", mb: 0.5 }}>{children}</Typography>,
  h2: ({ children }) => <Typography sx={{ fontWeight: 700, fontSize: "1.1em", mb: 0.5 }}>{children}</Typography>,
  h3: ({ children }) => <Typography sx={{ fontWeight: 700, fontSize: "1.05em", mb: 0.5 }}>{children}</Typography>,
};

export default function ChatMarkdown({ content, sx }) {
  return (
    <Box sx={{ "& > *:last-child": { mb: "0 !important" }, ...sx }}>
      <ReactMarkdown components={components}>{content || ""}</ReactMarkdown>
    </Box>
  );
}
